// Shared destructive-action confirm (house rule: trash icon, red CTA, explicit
// before→after wording). One overlay, built lazily, reused by every module —
// styled by the existing .tk-cf rules.
let host: HTMLDivElement | null = null;
let resolver: ((yes: boolean) => void) | null = null;

function ensureHost(): HTMLDivElement {
  if (host) return host;
  host = document.createElement("div");
  host.className = "tk-cf";
  host.id = "rpConfirm";
  host.innerHTML =
    `<div class="tk-cf-scrim" data-cf="no"></div>` +
    `<div class="tk-cf-box">` +
    `<div class="tk-cf-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg></div>` +
    `<h4></h4><p></p>` +
    `<button class="tk-cf-del" data-cf="yes"></button>` +
    `<button class="tk-cf-keep" data-cf="no">Cancel</button>` +
    `</div>`;
  host.addEventListener("click", (e) => {
    const b = (e.target as HTMLElement).closest<HTMLElement>("[data-cf]");
    if (!b) return;
    host?.classList.remove("open");
    const r = resolver;
    resolver = null;
    r?.(b.getAttribute("data-cf") === "yes");
  });
  document.body.appendChild(host);
  return host;
}

export function confirmDanger(o: { title: string; body: string; cta: string }): Promise<boolean> {
  return new Promise((resolve) => {
    const h = ensureHost();
    h.querySelector("h4")!.textContent = o.title;
    h.querySelector("p")!.textContent = o.body;
    h.querySelector(".tk-cf-del")!.textContent = o.cta;
    resolver?.(false); // a confirm opened over another one cancels the first
    resolver = resolve;
    h.classList.add("open");
  });
}
